export interface BrowserInfo {
  name: string;
  version: string;
  userAgent: string;
  platform: string;
  language: string;
  cookiesEnabled: boolean;
  isOnline: boolean;
  screenResolution: {
    width: number;
    height: number;
  };
}

export function getBrowserInfo(): BrowserInfo {
  const ua = navigator.userAgent;
  let browserName = 'Unknown';
  let version = 'Unknown';

  // Detect browser name and version
  if (ua.indexOf('Firefox') > -1) {
    browserName = 'Firefox';
    version = ua.match(/Firefox\/([0-9.]+)/)?.[1] || 'Unknown';
  } else if (ua.indexOf('Chrome') > -1 && ua.indexOf('Edg') === -1) {
    browserName = 'Chrome';
    version = ua.match(/Chrome\/([0-9.]+)/)?.[1] || 'Unknown';
  } else if (ua.indexOf('Edg') > -1) {
    browserName = 'Edge';
    version = ua.match(/Edg\/([0-9.]+)/)?.[1] || 'Unknown';
  } else if (ua.indexOf('Safari') > -1 && ua.indexOf('Chrome') === -1) {
    browserName = 'Safari';
    version = ua.match(/Version\/([0-9.]+)/)?.[1] || 'Unknown';
  } else if (ua.indexOf('MSIE') > -1 || ua.indexOf('Trident/') > -1) {
    browserName = 'Internet Explorer';
    version = ua.match(/(?:MSIE |rv:)([0-9.]+)/)?.[1] || 'Unknown';
  }

  return {
    name: browserName,
    version: version,
    userAgent: ua,
    platform: navigator.platform,
    language: navigator.language,
    cookiesEnabled: navigator.cookieEnabled,
    isOnline: navigator.onLine,
    screenResolution: {
      width: window.screen.width,
      height: window.screen.height,
    },
  };
}

export function isMobileDevice(): boolean {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  );
}

export function isWebpSupported(): boolean {
  const elem = document.createElement('canvas');
  if (elem.getContext && elem.getContext('2d')) {
    return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
  }
  return false;
}

export function isIos(): boolean {
  return (
    /iPad|iPhone/.test(navigator.userAgent) && !(window as any)['MSStream']
  );
}

export function isSafari(): boolean {
  const browserInfo = getBrowserInfo();
  return browserInfo.name === 'Safari';
}

export function isAndroid(): boolean {
  return /Android/.test(navigator.userAgent);
}
